! function($) {
    var body = $("body"),
        wishListsArr = localStorage.getItem("wishListsArr") ? JSON.parse(localStorage.getItem("wishListsArr")) : [];
    localStorage.setItem("wishListsArr", JSON.stringify(wishListsArr)), wishListsArr.length && (wishListsArr = JSON.parse(localStorage.getItem("wishListsArr"))), $(document).ready(function() {
        $(document).ajaxStart(function() {
            nuranium.isAjaxLoading = !0
        }), $(document).ajaxStop(function() {
            nuranium.isAjaxLoading = !1
        }), nuranium.init(), $("#popup-subscribe i.zmdi-close").on("click", function() {
            $(this).parents("#popup-subscribe").modal("hide")
        });
        var t = {
            shop: vinovathemes.main_info.shop,
            purchase_code: vinovathemes.main_info.lic,
            shopify_domain: vinovathemes.main_info.domain,
            status: vinovathemes.main_info.status
        };
        nuranium.validLicense(t)
    });
    var nuranium = {
        validLicense: function(t) {
            $.ajax({
                url: "https://vinovathemes.com/license/check_license.php",
                type: "post",
                data: t,
                success: function(t) {
                    var a = JSON.parse(t);
                    if ($("#Nov_purchasecode").on("contextmenu", function(t) {
                            t.preventDefault()
                        }), !1 == a.status) return $("#Nov_purchasecode").removeClass("hide hidden"), $("#Nov_purchasecode-waring").html(a.msg), !1;
                    a.status && ($("#Nov_purchasecode-waring").html(a.msg).slideDown(250), setTimeout(function() {
                        $("#Nov_purchasecode").remove()
                    }, 1e3))
                }
            })
        },
        isAjaxLoading: !1,
        init: function() {
            this.closeModal(), this.novProductTabs(), this.initNovWishListIcons(), this.doAddOrRemoveWishlistProduct(), this.doAddOrRemoveWishlist(), $("body").hasClass("template-page") && $(".wishlist-page").length && this.initNovWishListsPage(), this.ajaxProductAddToCart(), this.ajaxAddToCart(), this.ajaxChangeFromCart(), this.initMiniCart(), this.ajaxRemoveFromCart(), this.changeQuantityPageCart(), this.initCollapseSidebarBlock(), this.changeQuantityMiniCart(), this.initproductItemColorSwatch(), this.productItemSwatch(), this.togglePopupAddToCart(), body.hasClass("template-collection") && this.initCollectionPageLoadmore(), $(window).width() > 767 && this.initQuickView()
        },
        initCollectionPageLoadmore: function() {
            var t = $(".scroll__infitiny"),
                a = ".scroll__infitiny a";
            t.length && (body.off("click.initCollectionPageLoadmore", a).on("click.initCollectionPageLoadmore", a, function(t) {
                if (t.preventDefault(), t.stopPropagation(), !$(this).hasClass("disabled")) {
                    var a = $(this).data("href");
                    nuranium.ajaxCollectionPageLoadmoreGetContent(a)
                }
            }), $(window).scroll(function() {
                if (!nuranium.isAjaxLoading) {
                    var t, i, e = $(".collection-filter__content"),
                        n = e.offset().top + e.outerHeight() - $(window).height();
                    if ($(this).scrollTop() > n && $(this).scrollTop() < n + 200) {
                        var o = $(a);
                        if (o.length && !o.hasClass("disabled")) {
                            var s = o.data("href");
                            nuranium.ajaxCollectionPageLoadmoreGetContent(s)
                        }
                    }
                }
            }))
        },
        ajaxCollectionPageLoadmoreGetContent: function(t) {
            nuranium.isAjaxLoading || $.ajax({
                type: "GET",
                url: t,
                beforeSend: function() {
                    $(".scroll__infitiny").removeClass("loading").addClass("loading")
                },
                success: function(t) {
                    nuranium.ajaxCollectionPageLoadmoreMapData(t), $(".jdgm-widget").length && jdgm.customizeBadges(), Currency.convertAll(shopCurrency, $("#currencies span.selected").attr("data-currency"))
                },
                complete: function() {
                    $(".scroll__infitiny").removeClass("loading")
                }
            })
        },
        ajaxCollectionPageLoadmoreMapData: function(t) {
            var a = $(".collection-template"),
                i = a.find(".product-collection"),
                e = a.find(".paging"),
                n = $(t).find(".collection-template");
            if (newProductCollection = n.find(".product-collection"), newProductCount = n.find(".paging"), newProductItem = newProductCollection.children(".product--item"), e.replaceWith(newProductCount), newProductCollection.length) {
                i.append(newProductItem);
                var o = a.find(".product--item").length,
                    s = $(".pagination__bar").data("max");
                $(".pagination__count .count").text(o), $(".pagination__bar .progress").css("width", o / s * 100 + "%")
            }
        },
        togglePopupAddToCart: function() {
            $(".selector-wrapper-1").each(function() {
                $(this).hasClass("opt-color.hide") && $(this).closest(".item-product__popup--variant").find(".btn-close-quick-add").hide()
            }), $(document).on("click", ".btn-quick-add", function() {
                $(".item-product__popup--variant").removeClass("act"), $(this).parent().find(".item-product__popup--variant").addClass("act"), $(this).parents(".thumbnail-container").addClass("popup-act"), !0 == $(this).parents(".nov-slick-carousel").data("nav") && $(this).parents(".nov-slick-carousel").find(".slick-arrow").css("visibility", "hidden"), !0 == $(this).parents(".collection-carousel").data("nav") && $(this).parents(".collection-carousel").find(".slick-arrow").css("visibility", "hidden")
            }), $(document).on("click", ".btn-close-quick-add", function() {
                $(this).parent().removeClass("act"), $(this).parents(".thumbnail-container").removeClass("popup-act"), !0 == $(this).parents(".nov-slick-carousel").data("nav") && $(this).parents(".nov-slick-carousel").find(".slick-arrow").css("visibility", "visible"), !0 == $(this).parents(".collection-carousel").data("nav") && $(this).parents(".collection-carousel").find(".slick-arrow").css("visibility", "visible")
            })
        },
        initCollapseSidebarBlock: function() {
            $(document).on("click", ".facets__label--title", t => {
                var a = $(t.currentTarget),
                    i = a.parents(".js-filter").find(".facets__content");
                a.parent().hasClass("act") ? (a.parent().removeClass("act"), a.parents(".js-filter").removeClass("act"), i.slideUp()) : (a.parent().addClass("act"), a.parents(".js-filter").addClass("act"), i.slideDown())
            })
        },
        closeModal: function() {
            $(".close-modal, .overlay").click(function() {
                $(".loading-modal").css({
                    opacity: "0",
                    visibility: "hidden",
                    transform: "translateX(410px)",
                    transition: "all 0.3s"
                })
            })
        },
        novProductTabs: function() {
            $("[data-product-tabs]").each(function() {
                var t = $(this),
                    a = t.find(".list-product-tabs").find("[data-product-tabTop]"),
                    i = t.find("[data-product-TabContent]"),
                    e = t.find(".list-product-tabs .tab-links.active"),
                    n = t.find(".product-tabs-content .tab-content.active");
                nuranium.doAjaxNovProductTabs(e.data("href"), n.find(".products-grid"), a), a.off("click").on("click", function(t) {
                    if (t.preventDefault(), t.stopPropagation(), !$(this).hasClass("active") && !$(this).hasClass("active")) {
                        var e = $(this),
                            n = $(e.data("target"));
                        if (a.removeClass("active"), i.removeClass("active"), n.find(".collection-carousel").hasClass("slick-initialized") || nuranium.doAjaxNovProductTabs(e.data("href"), n.find(".products-grid"), a), e.addClass("active"), n.addClass("active"), n.find(".collection-carousel").hasClass("slick-initialized")) {
                            var o = $(n.find(".collection-carousel")),
                                s = o.find(".slick-slide").length,
                                r = o.find(".slick-active").length,
                                d = o.find(".slick-active:first").data("slick-index"),
                                l = o.find(".slick-active:last").data("slick-index") + 1,
                                c = o.parents("[data-product-tabs]").find(".nav-slider--prev"),
                                p = o.parents("[data-product-tabs]").find(".nav-slider--next");
                            s == r ? (c.css("visibility", "hidden"), p.css("visibility", "hidden")) : (c.css("visibility", "visible"), p.css("visibility", "visible")), 0 == d ? c.addClass("disabled") : c.removeClass("disabled"), s - l > 0 ? p.removeClass("disabled") : p.addClass("disabled")
                        }
                    }
                })
            })
        },
        doAjaxNovProductTabs: function(t, a, i) {
            $.ajax({
                type: "GET",
                url: window.router + t,
                beforeSend: function() {
                    i.css({
                        "pointer-events": "none",
                        opacity: "0.6"
                    })
                },
                success: function(e) {
                    if ("/collections/?view=json" == t || "/collections/?view=new-json" == t);
                    else {
                        a.html($(e).find(".grid-item").html());
                        var n = i.data("limit") - 1;
                        a.find(".block:gt(" + n + ")").remove(), a.hasClass("collection-carousel") && !a.hasClass("slick-initialized") && nuranium.initNovProductTabsSlider(a.parent()), Currency.convertAll(shopCurrency, $("#currencies span.selected").attr("data-currency")), nuranium.initNovWishListIcons(), setTimeout(function() {
                            if ($(".shopify-product-reviews-badge").length && $(".spr-badge").length) return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges()
                        }, 500)
                    }
                },
                complete: function() {
                    i.css({
                        "pointer-events": "auto",
                        opacity: "1"
                    })
                }
            })
        },
        initNovProductTabsSlider: function(t) {
            t.each(function() {
                var t = $(this).find(".products-grid"),
                    a = !!$("html").hasClass("lang-rtl");
                if (t.not(".slick-initialized")) {
                    function i(t, a) {
                        var i = $(t).find(".slick-slide").length,
                            e = $(t).find(".slick-active").length,
                            n = $(t).parents("[data-product-tabs]").find(".nav-slider--prev"),
                            o = $(t).parents("[data-product-tabs]").find(".nav-slider--next");
                        i - e == 0 ? (n.css("visibility", "hidden"), o.css("visibility", "hidden")) : (n.css("visibility", "visible"), o.css("visibility", "visible")), 0 == a ? n.addClass("disabled") : n.removeClass("disabled"), i - e <= a ? o.addClass("disabled") : o.removeClass("disabled")
                    }
                    t.slick({
                        nextArrow: '<div class="arrow-next"><i class="rbb-icon-direction-39"></i></div>',
                        prevArrow: '<div class="arrow-prev"><i class="rbb-icon-direction-36"></i></div>',
                        rtl: a,
                        slidesToShow: t.data("items_xxl"),
                        slidesToScroll: t.data("items_xxl"),
                        rows: t.data("row"),
                        row_mobile: t.data("row_mobile"),
                        arrows: t.data("nav"),
                        dots: t.data("dots"),
                        infinite: t.data("loop"),
                        adaptiveHeight: !0,
                        responsive: [{
                            breakpoint: 1440,
                            settings: {
                                slidesToShow: t.data("items"),
                                slidesToScroll: t.data("items")
                            }
                        }, {
                            breakpoint: 1200,
                            settings: {
                                slidesToShow: t.data("items_lg"),
                                slidesToScroll: t.data("items_lg"),
                                arrows: !1
                            }
                        }, {
                            breakpoint: 992,
                            settings: {
                                slidesToShow: t.data("items_md"),
                                slidesToScroll: t.data("items_md"),
                                arrows: !1
                            }
                        }, {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: t.data("items_sm"),
                                slidesToScroll: t.data("items_sm"),
                                arrows: !1
                            }
                        }, {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: t.data("items_xs"),
                                slidesToScroll: t.data("items_xs"),
                                arrows: !1,
                                rows: t.data("row_mobile")
                            }
                        }, ]
                    }), i(this, t.slick("slickCurrentSlide")), $(this).on("afterChange", function(t, a, e, n) {
                        i(this, e)
                    }), $("[data-product-tabs]").find(".nav-slider--prev").click(function() {
                        $(this).parents("[data-product-tabs]").find(".tab-content.active").find(t).slick("slickPrev")
                    }), $("[data-product-tabs]").find(".nav-slider--next").click(function() {
                        $(this).parents("[data-product-tabs]").find(".tab-content.active").find(t).slick("slickNext")
                    })
                }
            })
        },
        productItemSwatch: function() {
            $(document).on("change", ".selector-wrapper :radio", function(t) {
                var a, i = $(this),
                    e = i.parents(".item-product"),
                    n = i.parents(".product__popup-swatch"),
                    o = e.data("json-product").variants,
                    s = e.find(".opt-color").data("opt-position"),
                    r = i.closest("[data-option-index]").data("option-index"),
                    d = n.find(".swatch-element"),
                    l = i.val(),
                    c = n.find("[name=id]"),
                    p = n.find(".selector-wrapper-1").find("input:checked").val(),
                    u = n.find(".selector-wrapper-2").find("input:checked").val(),
                    v = n.find(".selector-wrapper-3").find("input:checked").val();
                switch (d.removeClass("soldout"), d.find(":radio").prop("disabled", !1), r) {
                    case 0:
                        var m = o.find(function(t) {
                            return 1 == s ? t.option2 == l && t.option1 == u : 2 == s ? t.option3 == l && t.option1 == u : t.option1 == l && t.option2 == u
                        });
                        if (void 0 != m) a = m;
                        else {
                            var h = o.find(function(t) {
                                return 1 == s ? t.option2 == l : 2 == s ? t.option3 == l : t.option1 == l
                            });
                            a = h
                        }
                        break;
                    case 1:
                        var m = o.find(function(t) {
                            return 1 == s ? t.option2 == p && t.option1 == l && t.option3 == v : 2 == s ? t.option3 == p && t.option1 == l && t.option2 == v : t.option1 == p && t.option2 == l && t.option3 == v
                        });
                        if (void 0 != m) a = m;
                        else {
                            var h = o.find(function(t) {
                                return 1 == s ? t.option2 == p && t.option1 == l : 2 == s ? t.option3 == p && t.option1 == l : t.option1 == p && t.option2 == l
                            });
                            a = h
                        }
                        break;
                    case 2:
                        var m = o.find(function(t) {
                            return 1 == s ? t.option2 == p && t.option1 == u && t.option3 == l : 2 == s ? t.option3 == p && t.option1 == u && t.option2 == l : t.option1 == p && t.option2 == u && t.option3 == l
                        });
                        void 0 != m && (a = m)
                }
                if (void 0 != a) {
                    c.val(a.id), a.compare_at_price > a.price ? e.find("[data-compare-price-grid]").html(Shopify.formatMoney(a.compare_at_price, theme.moneyFormat)) : e.find("[data-compare-price-grid]").html(""), e.find("[data-price-grid]").html(Shopify.formatMoney(a.price, theme.moneyFormat)), i.parents(".selector-wrapper").find(".form-label span").text(l), nuranium.checkStatusSwatch(e, n);
                    var f, _ = n.find(".current_variant_id").attr("value");
                    "continue" == n.find('.product-form__variants [value="' + _ + '"]').data("inventory_policy") ? n.find("[data-btn-addtocart] .add-to-cart-text").text(window.inventory_text.preorder) : n.find("[data-btn-addtocart] .add-to-cart-text").text(window.inventory_text.add_to_cart), Currency.convertAll(shopCurrency, $("#currencies span.selected").attr("data-currency"))
                }
            }), $(document).on("change", ".item-product__popup--variant select.single-option-selector", function() {
                var t, a = $(this),
                    i = a.parents(".item-product"),
                    e = a.parents(".product__popup-swatch"),
                    n = i.data("json-product").variants,
                    o = a.data("option"),
                    s = a.val(),
                    r = e.find("[name=id]"),
                    d = e.find('[data-option="option1"]').val(),
                    l = e.find('[data-option="option2"]').val();
                switch (e.find('[data-option="option3"]').val(), o) {
                    case "option1":
                        var c = n.find(function(t) {
                            return t.option1 == s && t.option2 == l && t.available
                        });
                        t = void 0 != c ? c : n.find(function(t) {
                            return t.option1 == s && t.available
                        });
                        break;
                    case "option2":
                        var c = n.find(function(t) {
                            return t.option1 == d && t.option2 == s && t.available
                        });
                        void 0 != c && (t = c);
                        break;
                    case "option3":
                        var c = n.find(function(t) {
                            return t.option1 == d && t.option2 == l && t.option3 == s && t.available
                        });
                        void 0 != c && (t = c)
                }
                void 0 != t && r.val(t.id), a.parents(".selector-wrapper").find(".form-label span").text(s), nuranium.checkStatusSwatch(i, e);
                var p = e.find(".current_variant_id").attr("value");
                "continue" == e.find('.product-form__variants [value="' + p + '"]').data("inventory_policy") ? e.find("[data-btn-addtocart] .add-to-cart-text").text(window.inventory_text.preorder) : e.find("[data-btn-addtocart] .add-to-cart-text").text(window.inventory_text.add_to_cart)
            }), $(document).on("click", ".selector-wrapper .unavailable :radio", function(t) {
                $(this).parents(".item-product").find("[data-btn-addtocart]").attr("disabled", "disabled")
            })
        },
        initproductItemColorSwatch: function() {
            var t = ".item-swatch li label";
            body.off("click.toggleClass").on("click.toggleClass", t, function() {
                var t = $(this),
                    a = t.attr("data-title").replace(/^\s+|\s+$/g, ""),
                    i = t.closest(".item");
                t.parents(".item-swatch").find("li label").removeClass("active"), t.addClass("active");
                var e = $(this).parents(".item-product").data("json-product");
                if (i.find("a").attr("href"), i.find(".product__label-color").find("[data-change-title]").text(a), void 0 != t.data("with-one-option")) {
                    var n = t.data("quantity"),
                        o = t.data("inventory_policy");
                    i.find('[name="id"]').val(t.data("with-one-option")), n > 0 ? (i.find("[data-btn-addtocart]").removeClass("disabled").removeAttr("disabled"), "continue" == o ? i.find("[data-btn-addtocart] .add-to-cart-text").text(window.inventory_text.preorder) : i.find("[data-btn-addtocart] .add-to-cart-text").text(window.inventory_text.add_to_cart)) : (i.find("[data-btn-addtocart]").addClass("disabled").attr("disabled", "disabled"), i.find("[data-btn-addtocart] .add-to-cart-text").text(window.inventory_text.sold_out));
                    var s = t.data("price"),
                        r = t.data("compare_at_price");
                    r > s ? i.find("[data-compare-price-grid]").html(Shopify.formatMoney(r, theme.moneyFormat)) : i.find("[data-compare-price-grid]").html(""), i.find("[data-price-grid]").html(Shopify.formatMoney(s, theme.moneyFormat)), Currency.convertAll(shopCurrency, $("#currencies span.selected").attr("data-currency"))
                } else void 0 != e && nuranium.checkStatusSwatch(t.parents(".item-product")), $(".template-collection").length ? t.parents(".product-collection").hasClass("products-list") ? i.find(".product-details").find('[data-value="' + a + '"]').find("label").trigger("click") : i.find(".product__popup-swatch:eq(0)").find('[data-value="' + a + '"]').find("label").trigger("click") : i.find('[data-value="' + a + '"]').find("label").trigger("click");
                var d = t.data("img");
                if (d) return i.find(".thumbnail-container .product__thumbnail, .thumbnail-container .product__thumbnail-second").attr({
                    "data-srcset": d,
                    "data-src": d,
                    src: d,
                    srcset: d
                }), !1
            }), body.off("click.showmore").on("click.showmore", ".item-swatch-more .show_more", function(t) {
                t.preventDefault(), t.stopPropagation(), $(this).parents(".item-swatch").toggleClass("show--more"), $(this).parents(".item-swatch").hasClass("show--more") ? $(this).children().text("-") : $(this).children().text("+")
            })
        },
        checkStatusSwatch: function(t, a) {
            if (window.use_color_swatch) {
                var i = t.data("json-product"),
                    e = i.variants,
                    n = t.find("[data-option-index]"),
                    o = t.find(".opt-color").data("opt-position");
                void 0 == a && (a = t);
                var s = a.find('[data-option-index="0"]').find("input:checked").val(),
                    r = a.find('[data-option-index="1"]').find("input:checked").val();
                a.find('[data-option-index="2"]').find("input:checked").val(), n.each(function() {
                    var t = $(this).data("option-index"),
                        a = $(this).find(".swatch-element");
                    switch (t) {
                        case 0:
                            a.each(function() {
                                var t = $(this).data("value"),
                                    a = e.find(function(a) {
                                        return 1 == o ? a.option2 == t && a.available : 2 == o ? a.option3 == t && a.available : a.option1 == t && a.available
                                    }),
                                    i = e.find(function(a) {
                                        return 1 == o ? a.option2 == t : 2 == o ? a.option3 == t : a.option1 == t
                                    });
                                void 0 == a ? void 0 == i ? ($(this).addClass("unavailable"), $(this).removeClass("soldout"), $(this).removeClass("available"), $(this).find(":radio").prop("checked", !1), $(this).attr("data-toggle", "modal"), $(this).attr("data-target", "#Form_newletter")) : ($(this).addClass("soldout"), $(this).removeClass("unavailable"), $(this).removeClass("available"), $(this).find(":radio").prop("disabled", !1), $(this).attr("data-toggle", "modal"), $(this).attr("data-target", "#Form_newletter")) : ($(this).removeClass("soldout"), $(this).removeClass("unavailable"), $(this).addClass("available"), $(this).find(":radio").prop("disabled", !1), $(this).removeAttr("data-toggle", "modal"), $(this).removeAttr("data-target", "#Form_newletter"))
                            });
                            break;
                        case 1:
                            a.each(function() {
                                var t = $(this).data("value"),
                                    a = e.find(function(a) {
                                        return 1 == o ? a.option2 == s && a.option1 == t && a.available : 2 == o ? a.option3 == s && a.option1 == t && a.available : a.option1 == s && a.option2 == t && a.available
                                    }),
                                    i = e.find(function(a) {
                                        return 1 == o ? a.option2 == s && a.option1 == t : 2 == o ? a.option3 == s && a.option1 == t : a.option1 == s && a.option2 == t
                                    });
                                void 0 == a ? void 0 == i ? ($(this).addClass("unavailable"), $(this).removeClass("soldout"), $(this).removeClass("available"), $(this).find(":radio").prop("checked", !1), $(this).attr("data-toggle", "modal"), $(this).attr("data-target", "#Form_newletter")) : ($(this).addClass("soldout"), $(this).removeClass("unavailable"), $(this).removeClass("available"), $(this).find(":radio").prop("disabled", !1), $(this).attr("data-toggle", "modal"), $(this).attr("data-target", "#Form_newletter")) : ($(this).removeClass("soldout"), $(this).removeClass("unavailable"), $(this).addClass("available"), $(this).find(":radio").prop("disabled", !1), $(this).removeAttr("data-toggle", "modal"), $(this).removeAttr("data-target", "#Form_newletter"))
                            });
                            break;
                        case 2:
                            a.each(function() {
                                var t = $(this).data("value");
                                $(this).data("inventory_policy");
                                var a = e.find(function(a) {
                                        return 1 == o ? a.option2 == s && a.option1 == r && a.option3 == t && a.available : 2 == o ? a.option3 == s && a.option1 == r && a.option2 == t && a.available : a.option1 == s && a.option2 == r && a.option3 == t && a.available
                                    }),
                                    i = e.find(function(a) {
                                        return 1 == o ? a.option2 == s && a.option1 == r && a.option3 == t : 2 == o ? a.option3 == s && a.option1 == r && a.option2 == t : a.option1 == s && a.option2 == r && a.option3 == t
                                    });
                                void 0 == a ? void 0 == i ? ($(this).addClass("unavailable"), $(this).removeClass("soldout"), $(this).removeClass("available"), $(this).find(":radio").prop("checked", !1), $(this).attr("data-toggle", "modal"), $(this).attr("data-target", "#Form_newletter")) : ($(this).addClass("soldout"), $(this).removeClass("unavailable"), $(this).removeClass("available"), $(this).find(":radio").prop("disabled", !1), $(this).attr("data-toggle", "modal"), $(this).attr("data-target", "#Form_newletter")) : ($(this).removeClass("soldout"), $(this).removeClass("unavailable"), $(this).addClass("available"), $(this).find(":radio").prop("disabled", !1), $(this).removeAttr("data-toggle", "modal"), $(this).removeAttr("data-target", "#Form_newletter"))
                            })
                    }
                }), a.find(".swatch-element.soldout").find("input:checked").length ? a.find("[data-btn-addtocart]").attr("disabled", !0) : a.find("[data-btn-addtocart]").removeAttr("disabled"), a.find(".selector-wrapper:not(.opt-color)").each(function() {
                    $(this).find(".swatch-element").find("input:checked").length < 1 && ($(this).find(".swatch-element.available").length ? $(this).find(".swatch-element.available").eq("0").find("label").trigger("click") : $(this).find(".swatch-element.soldout").eq("0").find("label").trigger("click"))
                })
            } else {
                var i = t.data("json-product"),
                    e = i.variants,
                    n = t.find(".item-product__popup--variant [data-option]"),
                    s = a.find('.item-product__popup--variant [data-option="option1"]').val(),
                    r = a.find('.item-product__popup--variant [data-option="option2"]').val();
                a.find('.item-product__popup--variant [data-option="option3"]').val(), n.each(function() {
                    var t = $(this).data("option-index"),
                        a = $(this).find("option");
                    switch (t) {
                        case 0:
                            a.each(function() {
                                var t = $(this).val();
                                void 0 == e.find(function(a) {
                                    return a.option1 == t && a.available
                                }) ? void 0 == e.find(function(a) {
                                    return a.option1 == t
                                }) ? ($(this).addClass("unavailable"), $(this).removeClass("soldOut"), $(this).attr("disabled", "disabled")) : ($(this).addClass("soldOut"), $(this).removeClass("unavailable"), $(this).removeAttr("disabled", "disabled")) : ($(this).removeAttr("disabled", "disabled"), $(this).removeClass("soldOut"), $(this).removeClass("unavailable"))
                            });
                            break;
                        case 1:
                            a.each(function() {
                                var t = $(this).val();
                                void 0 == e.find(function(a) {
                                    return a.option1 == s && a.option2 == t && a.available
                                }) ? void 0 == e.find(function(a) {
                                    return a.option1 == s && a.option2 == t
                                }) ? ($(this).addClass("unavailable"), $(this).removeClass("soldOut"), $(this).attr("disabled", "disabled")) : ($(this).addClass("soldOut"), $(this).removeClass("unavailable"), $(this).removeAttr("disabled", "disabled")) : ($(this).removeAttr("disabled", "disabled"), $(this).removeClass("soldOut"), $(this).removeClass("unavailable"))
                            });
                            break;
                        case 2:
                            a.each(function() {
                                var t = $(this).val();
                                void 0 == e.find(function(a) {
                                    return a.option1 == s && a.option2 == r && a.option3 == t && a.available
                                }) ? void 0 == e.find(function(a) {
                                    return a.option1 == s && a.option2 == r && a.option3 == t
                                }) ? ($(this).addClass("unavailable"), $(this).removeClass("soldOut"), $(this).attr("disabled", "disabled")) : ($(this).addClass("soldOut"), $(this).removeClass("unavailable"), $(this).removeAttr("disabled", "disabled")) : ($(this).removeAttr("disabled", "disabled"), $(this).removeClass("soldOut"), $(this).removeClass("unavailable"))
                            })
                    }
                }), a.find(".item-product__popup--variant .single-option-selector").find("option.soldOut:selected").length ? a.find("[data-btn-addtocart]").addClass("disabled").attr("disabled", !0) : a.find("[data-btn-addtocart]").removeClass("disabled").removeAttr("disabled")
            }
        },
        initNovWishListsPage: function() {
            "undefined" != typeof Storage ? !(wishListsArr.length <= 0) && wishListsArr.forEach(function(t) {
                nuranium.createNovWishListTplItem(t)
            }) : alert("Storage no support!")
        },
        initNovWishListIcons: function() {
            if (wishListsArr.length) {
                for (var t = 0; t < wishListsArr.length; t++) {
                    var a = $('[data-product-handle="' + wishListsArr[t] + '"]');
                    a.addClass("whislist-added"), a.find(".wishlist-text").text(theme.strings.remove_wishlist)
                }
                if ("undefined" != typeof Storage) {
                    if (wishListsArr.length <= 0) return;
                    setTimeout(function() {
                        wishListsArr.forEach(function(t) {
                            nuranium.setNovAddedForWishlistIcon(t)
                        })
                    }, 1e3)
                } else alert("Storage no support!")
            }
        },
        setNovAddedForWishlistIcon: function(t) {
            var a = $('[data-product-handle="' + t + '"]'),
                i = theme.strings.addto_wishlist,
                e = theme.strings.remove_wishlist;
            idxArr = wishListsArr.indexOf(t), $(".WishlistCount").text(wishListsArr.length), idxArr >= 0 ? (a.addClass("whislist-added"), a.find(".wishlist-text").text(e), a.attr("title", e)) : (a.removeClass("whislist-added"), a.find(".wishlist-text").text(i), a.attr("title", i))
        },
        doAddOrRemoveWishlist: function() {
            var t = ".item-product [data-icon-wishlist]",
                a = theme.strings.addto_wishlist,
                i = theme.strings.remove_wishlist;
            $(document).off("click.addOrRemoveWishlist", t).on("click.addOrRemoveWishlist", t, function(t) {
                t.preventDefault();
                var e = $(this),
                    n = e.data("id"),
                    o = e.data("product-handle"),
                    s = wishListsArr.indexOf(o);
                if (e.hasClass("whislist-added")) e.removeClass("whislist-added"), e.find(".wishlist-text").text(a), e.attr({
                    title: a,
                    "data-original-title": a
                }), $(".tooltip-inner").text(a), $('[data-wishlist-added="wishlist-' + n + '"]').length && $('[data-wishlist-added="wishlist-' + n + '"]').remove(), wishListsArr.splice(s, 1), localStorage.setItem("wishListsArr", JSON.stringify(wishListsArr));
                else {
                    e.addClass("whislist-added"), e.find(".wishlist-text").text(i), e.attr({
                        title: i,
                        "data-original-title": i
                    }), $(".tooltip-inner").text(i);
                    var r = e.parents(".item-product").find(".product__title").html(),
                        d = e.parents(".item-product").find(".product__thumbnail").attr("srcset") ? e.parents(".item-product").find(".product__thumbnail").attr("srcset") : e.parents(".item-product").find(".product__thumbnail").attr("src");
                    $(".loading-modal").find(".product-title").html(r), $(".loading-modal").find(".product-image").attr("srcset", d), $(".loading-modal").find(".btn-wishlist").show(), $(".loading-modal").css({
                        opacity: "1",
                        visibility: "initial",
                        transform: "translateX(0)",
                        transition: "all 0.3s"
                    }), $(".loading-modal").addClass("novload"), setTimeout(function() {
                        $(".loading-modal").css({
                            opacity: "0",
                            visibility: "hidden",
                            transform: "translateX(410px)",
                            transition: "all 0.3s"
                        }), $(".loading-modal").removeClass("novload")
                    }, 5e3), $("[data-wishlist-container]").length && nuranium.createNovWishListTplItem(o), wishListsArr.push(o), localStorage.setItem("wishListsArr", JSON.stringify(wishListsArr))
                }
                nuranium.setNovAddedForWishlistIcon(o)
            })
        },
        doAddOrRemoveWishlistProduct: function() {
            var t = ".product-single a[data-icon-wishlist]";
            $(document).off("click.addOrRemoveWishlist", t).on("click.addOrRemoveWishlist", t, function(t) {
                t.preventDefault();
                var a = $(this),
                    i = a.data("id"),
                    e = a.data("product-handle"),
                    n = wishListsArr.indexOf(e);
                if (a.hasClass("whislist-added")) a.removeClass("whislist-added"), a.find(".wishlist-text").text(theme.strings.addto_wishlist), $('[data-wishlist-added="wishlist-' + i + '"]').length && $('[data-wishlist-added="wishlist-' + i + '"]').remove(), wishListsArr.splice(n, 1), localStorage.setItem("wishListsArr", JSON.stringify(wishListsArr));
                else {
                    a.addClass("whislist-added"), a.find(".wishlist-text").text(theme.strings.remove_wishlist);
                    var o = a.parents(".product-single").find(".product-single__title").html(),
                        s = a.parents(".product-single").find(".product-single__photos .thumblist .thumbItem img").attr("src");
                    $(".loading-modal").find(".product-title").html(o), $(".loading-modal").find(".product-image").attr("src", s), $(".loading-modal").find(".btn-wishlist").show(), $(".loading-modal").css({
                        opacity: "1",
                        visibility: "initial",
                        transform: "translateX(0)",
                        transition: "all 0.3s"
                    }), $(".loading-modal").addClass("novload"), setTimeout(function() {
                        $(".loading-modal").css({
                            opacity: "0",
                            visibility: "hidden",
                            transform: "translateX(410px)",
                            transition: "all 0.3s"
                        }), $(".loading-modal").removeClass("novload")
                    }, 5e3), $("[data-wishlist-container]").length && nuranium.createNovWishListTplItem(e), wishListsArr.push(e), localStorage.setItem("wishListsArr", JSON.stringify(wishListsArr))
                }
                nuranium.setNovAddedForWishlistIcon(e)
            })
        },
        createNovWishListTplItem: function(t) {
            var a = $("[data-wishlist-container]");
            jQuery.getJSON(window.router + "/products/" + t + ".js", function(t) {
                var i = "",
                    e = Shopify.formatMoney(t.price_min, theme.moneyFormat),
                    n = Shopify.formatMoney(t.compare_at_price_min, theme.moneyFormat);
                JSON.stringify(t.variants), JSON.stringify(t.media), i += '<div class="item col-lg-3 col-md-4 col-6" data-wishlist-added="wishlist-' + t.id + '">', i += '<div class="item-product" data-product-id="product-' + t.handle + '">', i += '<div class="inner-top">', void 0 !== t.images[1] ? i += '<div class="product-top thumbnail-container has-multiimage">' : i += '<div class="product-top thumbnail-container">', i += '<a href="' + t.url + '">', i += '<img class="product__thumbnail" src="' + t.featured_image + '" alt="' + t.featured_image.alt + '">', void 0 !== t.images[1] && (i += '<img class="product__thumbnail-second" src="' + t.images[1] + '" alt="' + t.images[1].alt + '">'), i += "</a>", i += '<div class="button--top">', i += '<div class="productWishList">', i += '<a class="btnProductWishlist item-product__wishlist whislist-added" data-icon-wishlist href="#" data-product-handle="' + t.handle + '" data-id="' + t.id + '">', i += '<i class="zmdi zmdi-favorite"></i>', i += "</a>", i += "</div>", i += '<div class="productQuickView d-none d-md-block">', i += '<a class="btnProductQuickview" href="#" data-url="/products/' + t.handle + '?view=quick_view" data-product-url="/products/' + t.handle + '"  data-handle="' + t.handle + '" data-pid="' + t.id + '">', i += '<i class="zmdi zmdi-collection-image-o"></i>', i += "</a>", i += "</div>", i += "</div>", i += "</div>", i += '<div class="product__info">', i += '<div class="product__title"><a href="' + t.url + '" title="' + t.title + '">' + t.title + "</a></div>", n > e ? (i += '<div class="price-sale">', i += '<span class="special-price" data-price-grid>' + e + "</span>", i += '<span class="old-price" data-compare-price-grid>' + n + "</span>", i += "</div>") : (i += '<div class="price-regular">', i += "<span data-price-grid>" + e + "</span>", i += "</div>"), i += "</div></div></div>", a.append(i)
            })
        },
        ajaxAddToCart: function() {
            $(document).on("click", "button.btnAddToCart", function(t) {
                var a = $(this);
                t.preventDefault(), a.css("pointer-events", "none").addClass("loading"), $.ajax({
                    type: "POST",
                    url: "/cart/add.js",
                    data: a.parents("form").serialize(),
                    dataType: "json",
                    success: function(t) {
                        $.get("/cart?view=json", function(t) {
                            $("#cart-info").html(t)
                        }).always(function() {
                            Currency.convertAll(shopCurrency, $("#currencies span.selected").attr("data-currency")), "show_popup" == theme.cart_status && nuranium.initAddToCart(t.image, t.title), $(".form-cart__extent").length || nuranium.initCartExtend(), nuranium.updateMiniCart(), nuranium.PopupAddToCart(), a.parents("form").find(".product-form__item-error").addClass("hidden"), a.css("pointer-events", "auto").removeClass("loading"), $(document).find(".quickviewClose").trigger("click"), "show_minicart" == theme.cart_status && setTimeout(function() {
                                $("#desktop_cart").addClass("active"), $(".sidebar-overlay").addClass("act")
                            }, 300)
                        })
                    },
                    error: function(t, i) {
                        a.removeClass("loading").css("pointer-events", "auto"), a.parents("form").find(".product-form__item-error").removeClass("hidden")
                    }
                })
            })
        },
        initAddToCart: function(t, a) {
            $.ajax({
                url: "/cart/?view=upsell",
                dataType: "html",
                type: "GET",
                beforeSend: function() {
                    $("body").addClass("cart_popup_opened")
                },
                success: function(t) {
                    $.magnificPopup.open({
                        items: {
                            src: '<div class="nov-with-anim product-quickview popup-quick-view cart__popup cart__popup_upsell"><div id="content_cart__popup_nt">' + t + "</div></div>",
                            type: "inline"
                        },
                        removalDelay: 500,
                        closeMarkup: '<i class="zmdi zmdi-hc-fw zmdi-close"></i>',
                        callbacks: {
                            beforeOpen: function() {
                                this.st.mainClass = "nov-move-horizontal"
                            },
                            open: function() {
                                nuranium.PopupAddToCart(), Currency.convertAll(shopCurrency, $("#currencies span.selected").attr("data-currency"))
                            },
                            change: function() {},
                            close: function() {
                                $("body").hasClass("template-cart") ? window.location.reload() : ($("body").removeClass("cart_popup_opened"), $("body").removeClass("open_quick_variants"), $("body").removeClass("loading"), $("#content_cart__popup_nt").empty())
                            }
                        }
                    })
                },
                complete: function() {
                    if (nuranium.PopupAddToCart(), Currency.convertAll(shopCurrency, $("#currencies span.selected").attr("data-currency")), $(".loader").remove(), a) {
                        var t = '<div class="cart-message d-flex align-items-center mb-20"><i class="zmdi zmdi-notifications-active"></i><strong>' + a + "</strong> - " + theme.strings.cart_message_html + "</div>";
                        $(".cart-popup__content").prepend(t)
                    }
                },
                error: function() {
                    $(".loader").remove()
                }
            })
        },
        updateMiniCart: function() {
            Shopify.getCart(function(t) {
                nuranium.doUpdateMiniCart(t)
            })
        },
        doUpdateMiniCart: function(t) {
            $("#CartCount, #CartCountCavas").text(t.item_count), $("#cart_total").html(Shopify.formatMoney(t.total_price, theme.moneyFormat)), $(".cart-popup-heading span").html("There are " + t.item_count + " item(s) in your cart")
        },
        ajaxChangeFromCart: function() {
            /* Intentionally empty - change events handled by changeQuantityMiniCart */
        },
        PopupAddToCart: function() {
            function t(t, a) {
                $(".cart__popup").addClass("loading"), $.ajax({
                    type: "POST",
                    url: "/cart/change.js",
                    data: "quantity=" + a + "&id=" + t,
                    dataType: "json",
                    success: function(i) {
                        jQuery.get("/cart?view=up_ajax", function(i) {
                            i = jQuery(i);
                            var e = jQuery(i),
                                n = jQuery(e.get(0)).html(),
                                o = jQuery(e.get(2)).html(),
                                s = $(".cart__popup #" + t).find(".cart__popup-total .amount");
                            $(".cart__popup #" + t).find(".cart__popup-qty--input").val(a);
                            var r = parseFloat(s.data("price")) * a;
                            s.html(Shopify.formatMoney(r, theme.moneyFormat)), $("#cart__popup_total").html(n), $("#threshold_bar_popup").html(o)
                        }).always(function() {
                            Currency.convertAll(shopCurrency, $("#currencies span.selected").attr("data-currency")), $(".cart__popup").removeClass("loading")
                        }), $.get("/cart?view=json", function(t) {
                            $("#cart-info").html(t)
                        }).always(function() {
                            Currency.convertAll(shopCurrency, $("#currencies span.selected").attr("data-currency")), nuranium.updateMiniCart()
                        })
                    },
                    error: function(t, a) {
                        $(".cart__popup").removeClass("loading")
                    }
                })
            }
            $(document).on("click", ".cart__popup-qty", function(a) {
                a.preventDefault();
                var i = $(this),
                    e = i.siblings(".cart__popup-qty--input"),
                    n = e.attr("data-id"),
                    o = parseFloat(e.val()),
                    s = parseFloat(e.attr("step")),
                    r = parseFloat(e.attr("min")),
                    d = parseFloat(e.attr("max"));
                if (i.hasClass("cart__popup-qty--plus")) {
                    var l = o + s;
                    if (l > d && d > 0) {
                        e.val(d);
                        return
                    }
                } else if (i.hasClass("cart__popup-qty--minus")) {
                    var l = o - s;
                    if (0 === l) {
                        var c = parseInt(e.attr("value"));
                        e.val(c), i.parents(".cart__popup-item").find(".cart__popup-remove").trigger("click");
                        return
                    }
                    if (l < r) return;
                    if (o < 0) {
                        alert("Invalid");
                        return
                    }
                }
                t(n, l)
            }), $(document).on("click", ".cart__popup-remove", function(t) {
                t.preventDefault(), $(".cart__popup").addClass("loading");
                var a = $(this),
                    i = a.siblings(".cart__popup-quantity").find(".cart__popup-qty--input"),
                    e = a.find("a").attr("data-product-id"),
                    n = parseInt(i.val());
                $ptitle = a.parent(".cart__popup-item").find(".cart__popup-title a").text(), $(".cart__popup").addClass("loading"), $.ajax({
                    type: "POST",
                    url: "/cart/change.js",
                    data: "quantity=0&id=" + e,
                    dataType: "json",
                    success: function(t) {
                        jQuery.get("/cart?view=up_ajax", function(t) {}).always(function(t) {
                            t = jQuery(t);
                            var i = jQuery(t),
                                o = jQuery(i.get(0)).html(),
                                s = jQuery(i.get(2)).html();
                            $("#cart__popup_total").html(o), $("#threshold_bar_popup").html(s), $(".cart__popup #" + e).addClass("hide"), n > 0 ? $("#" + e + " input").val(n) : $(".cart__popup #" + e + " input").val(1), Currency.convertAll(shopCurrency, $("#currencies span.selected").attr("data-currency")), $(".cart__popup .cart-message").html('<i class="rbb-icon-delete-outline-2"></i> <strong>' + $ptitle + "</strong> - has been removed into your shopping cart."), $(".cart__popup .cart-message").removeClass("removed").addClass("removed"), $(".cart__popup").removeClass("loading"), a.parents(".cart__popup-item").remove()
                        }), $.get("/cart?view=json", function(t) {
                            $("#cart-info").html(t)
                        }).always(function() {
                            Currency.convertAll(shopCurrency, $("#currencies span.selected").attr("data-currency")), nuranium.updateMiniCart()
                        })
                    }
                })
            })
        },
        initMiniCart: function() {
            jQuery.getJSON("/cart.js", function(t) {
                $("#CartCount, #CartCountCavas").text(t.item_count);
                if (t.item_count > 0) {
                    $("#desktop_cart").addClass("item_count");
                    $.get("/cart?view=json", function(html) {
                        $("#cart-info").html(html);
                    }).always(function() {
                        Currency.convertAll(shopCurrency, $("#currencies span.selected").attr("data-currency"));
                        $("#cart_total").html(Shopify.formatMoney(t.total_price, theme.moneyFormat));
                        var ih = $(".ajaxcart__inner").outerHeight(),
                            fh = $(".ajaxcart__footer").outerHeight(),
                            ch = $(".ajaxcart").height() - 30;
                        if (ih + fh >= ch) $(".ajaxcart__footer").addClass("h_scroll");
                        $(".form-cart__extent").length || nuranium.initCartExtend();
                    });
                } else {
                    var l = $(".link_to_collection_cart_empty").html(),
                        a = "";
                    a += '<div class="cart cart_empty">';
                    a += '<div class="empty_title text-center">' + theme.strings.cart_empty + "</div>";
                    a += '<div class="text-center mt-40 block_link_cart">';
                    a += "" + l;
                    a += "</div>";
                    a += "</div>";
                    $("#cart-info").html("").append(a);
                    $("#cart_total").html("$0");
                    $("#desktop_cart").removeClass("item_count");
                    $(".form-cart__extent").remove();
                }
            });
        },
        ajaxProductAddToCart: function() {
            $(document).on("click", ".product-form__cart-submit", function(t) {
                t.preventDefault();
                var a = $(this);
                a.css("pointer-events", "none").addClass("loading"), $(".lookbook-modal").modal("hide"), $.ajax({
                    type: "POST",
                    url: "/cart/add.js",
                    data: a.parents("form").serialize(),
                    dataType: "json",
                    success: function(t) {
                        $.get("/cart?view=json", function(t) {
                            $("#cart-info").html(t)
                        }).always(function() {
                            Currency.convertAll(shopCurrency, $("#currencies span.selected").attr("data-currency")), "show_popup" == theme.cart_status && nuranium.initAddToCart(t.image, t.title), $(".form-cart__extent").length || nuranium.initCartExtend(), nuranium.updateMiniCart(), nuranium.PopupAddToCart(), a.css("pointer-events", "auto").removeClass("loading"), $(".cart_extend").removeClass("act"), $(".cart_extend--label").removeClass("act")
                        })
                    },
                    complete: function() {
                        $("body").removeClass("cart_popup_opened"), $("body").removeClass("loading"), $(".nov-close, .cart_popup_opened .nov-ready").on("click", function() {
                            $("body").hasClass("template-cart") && window.location.reload()
                        }), "show_minicart" == theme.cart_status && setTimeout(function() {
                            $("#desktop_cart").addClass("active"), $(".sidebar-overlay").addClass("act")
                        }, 1e3)
                    },
                    error: function(t, i) {
                        a.removeClass("loading").css("pointer-events", "auto").find(".add-to-cart-text").text(window.inventory_text.sold_out)
                    }
                }).done(function() {
                    $("body").removeClass("loading")
                })
            })
        },
        initQuickView: function() {
            $(document).on("click", ".btnProductQuickview", function(t) {
                t.preventDefault(), $(".lookbook-modal").modal("hide");
                var a = $(this);
                $.ajax({
                    beforeSend: function() {
                        $("body").addClass("open_gl_quick_view")
                    },
                    url: a.attr("data-url"),
                    success: function(t) {
                        $.magnificPopup.open({
                            items: {
                                src: '<div class="nov-with-anim popup-quick-view" id="content_quickview">' + t + "</div>",
                                type: "inline"
                            },
                            removalDelay: 500,
                            closeMarkup: '<i class="zmdi zmdi-hc-fw zmdi-close"></i>',
                            callbacks: {
                                beforeOpen: function() {
                                    this.st.mainClass = "nov-move-horizontal"
                                },
                                open: function() {
                                    rtl = !!$("html").hasClass("lang-rtl"), $(".quickview_slick").slick({
                                        nextArrow: '<div class="arrow-next"><i class="zmdi zmdi-chevron-right"></i></div>',
                                        prevArrow: '<div class="arrow-prev"><i class="zmdi zmdi-chevron-left"></i></div>',
                                        rtl: rtl,
                                        slidesToShow: 1,
                                        slidesToScroll: 1,
                                        arrows: !0,
                                        dots: !1,
                                        infinite: !0,
                                        adaptiveHeight: !0
                                    }), $("variant-radios label").click(function() {
                                        setTimeout(function() {
                                            var t = $(".quickview_slick").find(".item.act").attr("data-slick-index");
                                            $(".quickview_slick").slick("slickGoTo", t)
                                        }, 300)
                                    }), Shopify.PaymentButton.init(), Currency.convertAll(shopCurrency, $("#currencies span.selected").attr("data-currency")), setTimeout(function() {
                                        if ($(".shopify-product-reviews-badge").length && $(".spr-badge").length) return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges()
                                    }, 1e3), nuranium.initNovWishListIcons(), $(".jdgm-widget").length && jdgm.customizeBadges(), jQuery("variant-radios :radio").change(function() {
                                        jQuery(this).closest(".swatch").attr("data-option-index");
                                        var t = jQuery(this).val();
                                        jQuery(this).parents("fieldset").find(".variant_current").text(t)
                                    }), $(document).on("click", "#content_quickview .soldout", function() {
                                        $("#content_quickview .zmdi-close").trigger("click")
                                    })
                                },
                                close: function() {
                                    $("#content_quickview").empty(), $("body").removeClass("open_gl_quick_view"), $("body").removeClass("cart_popup_opened"), $("body").removeClass("open_quick_variants"), $("body").find(".tooltip").remove()
                                }
                            }
                        })
                    },
                    complete: function() {
                        Shopify.PaymentButton.init()
                    }
                }).done(function() {
                    a.removeClass("btn-loading"), $("body").removeClass("loading"), $("body").find(".tooltip").remove()
                });
                let i = this.getAttribute("data-product-url");
                fetch(i).then(t => t.text()).then(t => {
                    let a = new DOMParser().parseFromString(t, "text/html"),
                        i = a.querySelector(".product-template__container").getAttribute("data-section-id"),
                        e = document.getElementById("content_quickview");
                    e.querySelector("variant-radios").setAttribute("data-section", i), e.querySelector(".product-template__container").setAttribute("data-section-id", i), e.querySelector(".product-template__container").id = "ProductSection-" + i, e.querySelector("#ProductPrice-templateQV").id = "ProductPrice-" + i, e.querySelector("#ComparePrice-templateQV") && (e.querySelector("#ComparePrice-templateQV").id = "ComparePrice-" + i), e.querySelector("form").id = "product-form-" + i, e.querySelector("form").setAttribute("data-section", i), item = e.querySelectorAll(".item_img");
                    for (var n = 0; n < item.length; n++) mediaId = item[n].getAttribute("data-media-id"), item[n].setAttribute("data-media-id", i + mediaId);
                    input = e.querySelectorAll("input[type=radio]");
                    for (var n = 0; n < input.length; n++) input[n].setAttribute("form", i)
                })
            })
        },
        ajaxRemoveFromCart: function() {
            $("#cart-info").on("click", ".remove-from-cart", function(t) {
                t.preventDefault();
                var a = $(this).attr("data-product-id");
                $.ajax({
                    type: "POST",
                    url: "/cart/change.js",
                    data: "quantity=0&id=" + a,
                    dataType: "json",
                    success: function(t) {
                        $("body").hasClass("template-cart") ? window.location.reload() : nuranium.initMiniCart()
                    }
                })
            })
        },
        changeQuantityMiniCart: function() {
            var busy = false;

            function doChange(variantId, qty) {
                if (busy) return;
                busy = true;

                $.ajax({
                    type: "POST",
                    url: "/cart/change.js",
                    data: "quantity=" + qty + "&id=" + variantId,
                    dataType: "json",
                    success: function(cart) {
                        $("#CartCount, #CartCountCavas").text(cart.item_count);
                        $("#cart_total").html(Shopify.formatMoney(cart.total_price, theme.moneyFormat));

                        if (cart.item_count === 0 && $("body").hasClass("template-cart")) {
                            window.location.reload();
                            return;
                        }

                        /* Single GET to refresh drawer — no more race condition */
                        $.get("/cart?view=json", function(html) {
                            $("#cart-info").html(html);
                        }).always(function() {
                            Currency.convertAll(shopCurrency, $("#currencies span.selected").attr("data-currency"));
                            nuranium.updateMiniCart();

                            if ($("#threshold_bar_popup").length) {
                                $.get("/cart?view=ship", function(h) {
                                    $("#threshold_bar_popup").html(h);
                                    setTimeout(function() {
                                        Currency.convertAll(shopCurrency, $("#currencies span.selected").attr("data-currency"));
                                    }, 200);
                                });
                            }

                            busy = false;
                        });
                    },
                    error: function() {
                        busy = false;
                    }
                });
            }

            $(document).on("click", ".cart__mini-qty", function(e) {
                e.preventDefault();
                if (busy) return;

                var $btn   = $(this),
                    $input = $btn.siblings(".cart__mini-qty--input"),
                    id     = $input.attr("data-id"),
                    val    = parseInt($input.val(), 10) || 1,
                    step   = parseInt($input.attr("step"), 10) || 1,
                    min    = parseInt($input.attr("min"), 10) || 1,
                    max    = parseInt($input.attr("max"), 10),
                    next;

                if ($btn.hasClass("cart__mini-qty--plus")) {
                    next = val + step;
                    if (!isNaN(max) && max > 0 && next > max) {
                        next = max;
                        if (next === val) return;
                    }
                } else if ($btn.hasClass("cart__mini-qty--minus")) {
                    next = val - step;
                    if (next <= 0) {
                        $btn.parents(".ajaxcart__product").find(".remove-from-cart").trigger("click");
                        return;
                    }
                    if (next < min) return;
                } else {
                    return;
                }

                $input.val(next);
                doChange(id, next);
            });

            $(document).on("change", ".cart__mini-qty--input", function(e) {
                if (busy) return;

                var $input = $(this),
                    id  = $input.attr("data-id"),
                    val = parseInt($input.val(), 10),
                    min = parseInt($input.attr("min"), 10) || 1,
                    max = parseInt($input.attr("max"), 10);

                if (isNaN(val) || val < 0) { $input.val(min); return; }
                if (val === 0) {
                    $input.parents(".ajaxcart__product").find(".remove-from-cart").trigger("click");
                    return;
                }
                if (!isNaN(max) && max > 0 && val > max) { val = max; $input.val(val); }
                if (val < min) { val = min; $input.val(val); }

                doChange(id, val);
            });
        },
        changeQuantityPageCart: function() {
            function t(t, a, i) {
                var e = {
                    type: "POST",
                    url: "/cart/change.js",
                    data: "quantity=" + a + "&line=" + t,
                    dataType: "json",
                    success: function(t) {
                        "function" == typeof i && i(t)
                    },
                    error: function(t, a) {}
                };
                jQuery.ajax(e)
            }
            $(document).on("change keyup", ".cart__qty-input, .cart__popup-qty--input", function() {
                var a = $(this),
                    i = a.data("line"),
                    e = parseInt(a.val()),
                    n = a.data("price"),
                    o = a.attr("max");
                if (isNaN(e)) return 0;
                o = isNaN(parseInt(o)) ? 9999 : parseInt(o), e > o && a.attr("value", o).val(o), (e = e > o ? o : e) <= 0 && a.closest("tr").remove(), t(i, e, function(t) {
                    $(".cart__subtotal").html(Shopify.formatMoney(t.total_price, theme.moneyFormat)), a.parents(".cart_item").find(".product-subtotal").html(Shopify.formatMoney(n * e, theme.moneyFormat)), $("#CartCount, #CartCountCavas").html(t.item_count), $(".cart__heading span").html("There are " + t.item_count + " items in your cart"), Currency.convertAll(shopCurrency, $("#currencies span.selected").attr("data-currency")), jQuery.get("/cart?view=ship", function(t) {
                        $("#threshold_bar_popup").html(t), setTimeout(function() {
                            Currency.convertAll(shopCurrency, $("#currencies span.selected").attr("data-currency"))
                        }, 200)
                    }), $.get("/cart?view=json", function(t) {
                        $("#cart-info").html(t)
                    }).always(function() {
                        Currency.convertAll(shopCurrency, $("#currencies span.selected").attr("data-currency")), nuranium.updateMiniCart()
                    })
                })
            }), $(document).on("click", ".plus, .minus", function() {
                var t = $(this).closest(".cart__qty").find(".cart__qty-input"),
                    a = parseFloat(t.val()),
                    i = parseFloat(t.attr("max")),
                    e = parseFloat(t.attr("min")),
                    n = t.attr("step");
                a && "" !== a && "NaN" !== a || (a = 0), ("" === i || "NaN" === i) && (i = ""), ("" === e || "NaN" === e) && (e = 0), ("any" === n || "" === n || void 0 === n || "NaN" === parseFloat(n)) && (n = 1), $(this).is(".plus") ? i && a >= i ? t.val(i) : t.val(a + parseFloat(n)) : e && a <= e ? t.val(e) : a > 0 && t.val(a - parseFloat(n)), t.trigger("change")
            }), $(document).on("click", ".quick_view-qty-plus, .quick_view-qty-minus", function() {
                var t = $(this).closest(".quick_view_qty").find('input[name="quantity"]'),
                    a = parseFloat(t.val()),
                    i = parseFloat(t.attr("max")),
                    e = parseFloat(t.attr("min")),
                    n = t.attr("step");
                a && "" !== a && "NaN" !== a || (a = 0), ("" === i || "NaN" === i) && (i = ""), ("" === e || "NaN" === e) && (e = 0), ("any" === n || "" === n || void 0 === n || "NaN" === parseFloat(n)) && (n = 1), $(this).is(".quick_view-qty-plus") ? i && a >= i ? t.val(i) : t.val(a + parseFloat(n)) : e && a <= e ? t.val(e) : a > 0 && t.val(a - parseFloat(n))
            })
        },
        initCartExtend: function() {
            jQuery.get("/cart?view=extend", function(t) {
                $(".block_cart_top").before(t), $("html").hasClass("lang-rtl") ? $(".extend--label__item").attr("data-placement", "right") : $(".extend--label__item").attr("data-placement", "left")
            }), setTimeout(function() {
                if ($("#shipping-calculator").length > 0) {
                    var _config, _render, _enableButtons, _disableButtons, _getCartShippingRatesForDestination, _pollForCartShippingRatesForDestination, _fullMessagesFromErrors, _onError, _onCartShippingRatesUpdate, _formatRate;
                    "object" == typeof Countries && (Countries.updateProvinceLabel = function(t, a) {
                        if ("string" == typeof t && Countries[t] && Countries[t].provinces && ("object" == typeof a || null !== (a = document.getElementById("address_province_label")))) {
                            a.innerHTML = Countries[t].label;
                            var i = jQuery(a).parent();
                            i.find("select"), i.find(".custom-style-select-box-inner").html(Countries[t].provinces[0])
                        }
                    }), void 0 === Shopify.Cart && (Shopify.Cart = {}), Shopify.Cart.ShippingCalculator = (_config = {
                        submitButton: "Calculate shipping",
                        submitButtonDisabled: "Calculating...",
                        templateId: "shipping-calculator-response-template",
                        wrapperId: "wrapper-response",
                        customerIsLoggedIn: !1,
                        moneyFormat: "${{amount}}"
                    }, _render = function(t) {
                        var a = jQuery("#" + _config.templateId),
                            i = jQuery("#" + _config.wrapperId);
                        if (a.length && i.length) {
                            var e = Handlebars.compile(jQuery.trim(a.text()))(t);
                            if (jQuery(e).appendTo(i), "undefined" != typeof Currency && "function" == typeof Currency.convertAll) {
                                var n = "";
                                jQuery("[name=currencies]").length > 0 ? n = jQuery("[name=currencies]").val() : jQuery("#currencies span.selected").length > 0 && (n = jQuery("#currencies span.selected").attr("data-currency")), "" !== n && Currency.convertAll(shopCurrency, n, "#wrapper-response span.money, #estimated-shipping span.money")
                            }
                        }
                    }, _enableButtons = function() {
                        jQuery(".get-rates").removeAttr("disabled").removeClass("disabled").val(_config.submitButton)
                    }, _disableButtons = function() {
                        jQuery(".get-rates").val(_config.submitButtonDisabled).attr("disabled", "disabled").addClass("disabled")
                    }, _getCartShippingRatesForDestination = function(t) {
                        var a = {
                            type: "POST",
                            url: "/cart/prepare_shipping_rates",
                            data: jQuery.param({
                                shipping_address: t
                            }),
                            success: _pollForCartShippingRatesForDestination(t),
                            error: _onError
                        };
                        jQuery.ajax(a)
                    }, _pollForCartShippingRatesForDestination = function(t) {
                        var a = function() {
                            jQuery.ajax("/cart/async_shipping_rates", {
                                dataType: "json",
                                success: function(i, e, n) {
                                    200 === n.status ? _onCartShippingRatesUpdate(i.shipping_rates, t) : setTimeout(a, 500)
                                },
                                error: _onError
                            })
                        };
                        return a
                    }, _fullMessagesFromErrors = function(t) {
                        var a = [];
                        return jQuery.each(t, function(t, i) {
                            jQuery.each(i, function(i, e) {
                                a.push(t + " " + e)
                            })
                        }), a
                    }, _onError = function(XMLHttpRequest, textStatus) {
                        jQuery("#estimated-shipping").hide(), jQuery("#estimated-shipping em").empty(), _enableButtons();
                        var feedback = "",
                            data = eval("(" + XMLHttpRequest.responseText + ")");
                        "Error : country is not supported." == (feedback = data.message ? data.message + "(" + data.status + "): " + data.description : "Error : " + _fullMessagesFromErrors(data).join("; ") + ".") && (feedback = "We do not ship to this destination."), _render({
                            rates: [],
                            errorFeedback: feedback,
                            success: !1
                        }), jQuery("#" + _config.wrapperId).show()
                    }, _onCartShippingRatesUpdate = function(t, a) {
                        _enableButtons();
                        var i = "";
                        if (a.zip && (i += a.zip + ", "), a.province && (i += a.province + ", "), i += a.country, t.length) {
                            "0.00" == t[0].price ? jQuery("#estimated-shipping em").html("FREE") : jQuery("#estimated-shipping em").html(_formatRate(t[0].price));
                            for (var e = 0; e < t.length; e++) t[e].price = _formatRate(t[e].price)
                        }
                        _render({
                            rates: t,
                            address: i,
                            success: !0
                        }), jQuery("#" + _config.wrapperId + ", #estimated-shipping").fadeIn()
                    }, _formatRate = function(t) {
                        function a(t, a) {
                            return void 0 === t ? a : t
                        }

                        function i(t, i, e, n) {
                            if (i = a(i, 2), e = a(e, ","), n = a(n, "."), isNaN(t) || null == t) return 0;
                            var o, s = (t = (t / 100).toFixed(i)).split(".");
                            return s[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + e) + (s[1] ? n + s[1] : "")
                        }
                        if ("function" == typeof Shopify.formatMoney) return Shopify.formatMoney(t, _config.moneyFormat);
                        "string" == typeof t && (t = t.replace(".", ""));
                        var e = "",
                            n = /\{\{\s*(\w+)\s*\}\}/,
                            o = _config.moneyFormat;
                        switch (o.match(n)[1]) {
                            case "amount":
                                e = i(t, 2);
                                break;
                            case "amount_no_decimals":
                                e = i(t, 0);
                                break;
                            case "amount_with_comma_separator":
                                e = i(t, 2, ".", ",");
                                break;
                            case "amount_no_decimals_with_comma_separator":
                                e = i(t, 0, ".", ",")
                        }
                        return o.replace(n, e)
                    }, _init = function() {
                        new Shopify.CountryProvinceSelector("address_country", "address_province", {
                            hideElement: "address_province_container"
                        });
                        var t = jQuery("#address_country"),
                            a = jQuery("#address_province_label").get(0);
                        "undefined" != typeof Countries && (Countries.updateProvinceLabel(t.val(), a), t.change(function() {
                            Countries.updateProvinceLabel(t.val(), a)
                        })), jQuery(".get-rates").click(function() {
                            _disableButtons(), jQuery("#" + _config.wrapperId).empty().hide();
                            var t = {};
                            t.zip = jQuery("#address_zip").val() || "", t.country = jQuery("#address_country").val() || "", t.province = jQuery("#address_province").val() || "", _getCartShippingRatesForDestination(t)
                        }), _config.customerIsLoggedIn && jQuery(".get-rates:eq(0)").trigger("click")
                    }, {
                        show: function(t) {
                            t = t || {}, jQuery.extend(_config, t), jQuery(function() {
                                _init()
                            })
                        },
                        getConfig: function() {
                            return _config
                        },
                        formatRate: function(t) {
                            return _formatRate(t)
                        }
                    }), Shopify.Cart.ShippingCalculator.show({
                        submitButton: theme.strings.shippingCalcSubmitButton,
                        submitButtonDisabled: theme.strings.shippingCalcSubmitButtonDisabled,
                        customerIsLoggedIn: theme.strings.shippingCalcCustomerIsLoggedIn,
                        moneyFormat: theme.strings.shippingCalcMoneyFormat
                    })
                }
            }, 1e3)
        }
    }
}(jQuery);